import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GlobalComponent } from '../../global-component';
import { Observable } from 'rxjs';
import { CurrentUser } from '../models/currentuser.models';
import { TokenStorageService } from './token-storage.service';
import { TeamModel } from '../models/team.models';


const BASE_URL = GlobalComponent.BASE_API_URL;
const AUTH_API = BASE_URL + GlobalComponent.AUTH_API;

@Injectable({ providedIn: 'root' })

/**
 * Team-service Component
 */
export class TeamService {

    currentuser!: CurrentUser;

    constructor(private http: HttpClient, private tokenService: TokenStorageService) {
        this.currentuser = this.tokenService.getCurrentUser();
    }

    /**
     * Performs the add team member
     * @param email email
     * @param password password
     */
    addTeamMember(postdata: any): Observable<any> {
        // let currentuser = this.tokenService.getCurrentUser();
        //  const postData = {
        //      username: email,
        //      email: email,
        //      role: role,
        //      usertype: currentuser && currentuser?.user ? currentuser?.user?.usertype : null,
        //      provider: 'local',
        //      source: 'web',
        //      registereddomain: email.substring(email.lastIndexOf('@') + 1),
        //      name: name,
        //      masterguid: currentuser && currentuser?.user ? (currentuser?.user?.role?.type == 'super_admin' ? currentuser?.user?.guid : currentuser?.user?.masterguid) : null,
        //      parentguid: currentuser && currentuser?.user ? currentuser?.user?.guid : null,
        //      vendorguid: this.tokenService.getVendorGUID()!,
        //      isprelimuser: isprelimuser,
        //      isproductionuser: isproductionuser,
        //      isqcuser: isqcuser
        //    };

        // Register Api
        return this.http.post<any>(AUTH_API + 'local/register', postdata);
    }

    // Get Team Members
    getMembersData(isblocked: boolean, limit: number, skip: number): Observable<TeamModel> {
        let userData = this.tokenService.getUser();
        return this.http.get<TeamModel>(BASE_URL + (userData?.usertype == 'vendor' ? GlobalComponent.vendorMembersGet : GlobalComponent.clientMemberGet) + "?blocked=" + isblocked + "&orderby=DESC&skip=" + skip + "&limit=" + limit);
    }

    updateTeamsProfile(guid: string, data: any): Observable<any> {
        return this.http.put<any>(BASE_URL + `update-profile/${guid}`, data);
    }

    // Get Team Members Access Rights
    getMemberAccessRights(guid: number): Observable<any> {
        return this.http.get<any>(BASE_URL + "useraccessrights" + "?filters[userguid]=" + guid);
    }
}